module.exports = __webpack_public_path__ + "static/img/122_TO8_1666_og.29655c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/122_TO8_1666_og.jpg
// module id = yIs2
// module chunks = 0